import React, { memo } from 'react';
import { Route } from 'react-router';

import { useStyles } from './styles';
import moment from 'moment';
const packageJson = require('../../../../../package.json');

export interface IProtectedRouteProps {
  path: string;
  exact?: boolean;
  render: any;
}

const PublicRoute = ({ path, exact, render: RenderComponent }: IProtectedRouteProps) => {
  const classes = useStyles();
  return (
    <Route
      path={path}
      exact={exact}
      render={props => {
        return (
          <div className={classes.parent}>
            <RenderComponent {...props} />
            <footer className={classes.footer}>
              <p>
                Build version {packageJson.buildVersion} published on {packageJson.buildDate && moment(packageJson.buildDate).format('MMM DD, YYYY')}
              </p>
            </footer>
          </div>
        );
      }}
    />
  );
};

export default memo(PublicRoute);
